import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable React Error Overlay in development
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    // Filter out React error overlay messages
    if (
      typeof args[0] === 'string' &&
      args[0].includes('Error: ')
    ) {
      return;
    }
    originalError.call(console, ...args);
  };
}

// Prevent unhandled errors from showing red overlay
window.addEventListener('error', (event) => {
  // Log to console but prevent default error handling
  console.error('Caught error:', event.error);
  event.preventDefault();
});

window.addEventListener('unhandledrejection', (event) => {
  // Log to console but prevent default handling
  console.error('Caught unhandled rejection:', event.reason);
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
